// Mobile App Tour
// The mobile app: conversations, contacts, calendar and notifications on the go
// Selector policy: step 1 pins to the LIVE-VERIFIED sidebar id (#sb_location-mobile-app); the teaching steps are
// deliberate centered cards — no guessed element selectors (a wrong spotlight is worse than none).

export const mobileAppTour = {
  id: 'mobile-app',
  name: 'Mobile App Tour',
  displayName: 'Run Your Business From Your Phone',
  description: 'The mobile app: conversations, contacts, calendar and notifications on the go',
  estimatedDuration: '3 minutes',
  category: 'feature',
  autoStart: false,
  prerequisiteTours: ['ftux'],

  config: {
    animate: true,
    overlayOpacity: 0.75,
    smoothScroll: true,
    allowClose: true,
    showProgress: true
  },

  steps: [
    {
      element: '#sb_location-mobile-app',
      popover: {
        title: "📱 Welcome to the Mobile App",
        description: `
          Your business does not stop when you leave your desk. The mobile app puts conversations, contacts, and your calendar in your pocket.
        `,
        side: 'right',
        align: 'center'
      }
    },

    {
      popover: {
        title: "💬 Conversations Anywhere",
        description: `
          Reply to texts, emails, and social messages from your phone. Customers get a fast answer; you do not have to be at a laptop to give it.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "👤 Contacts On the Go",
        description: `
          Look up any **contact**, see their history, add a note after a call, or update a detail while you are still standing in their driveway.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📅 Your Calendar in Your Pocket",
        description: `
          See today at a glance, book an appointment on the spot, and get reminders before you are late.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🔔 Notifications That Matter",
        description: `
          Turn on **push notifications** for new leads and inbound messages — speed to lead is the difference between a booked job and a missed one.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎨 A Branded App",
        description: `
          On the right plan the app carries **your** name and logo, so clients experience your brand, not ours.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎉 Your Office Is Mobile",
        description: `
          You can now:

✅ Handle conversations from anywhere
✅ Look up and update contacts
✅ Manage your calendar on the go
✅ Get notified the moment a lead arrives

**Next:** install the app, enable notifications, and reply to one message from your phone.
        `,
        side: 'over',
        align: 'center',
        showButtons: ['close'],
        doneBtnText: 'Done →'
      }
    }
  ]
};
